import { Flex, Group } from '@mantine/core';
import { IconUserPlus, IconUpload } from '@tabler/icons-react';
import { TableActionButton } from 'components/common';

import { Payor, Provider, Site, User } from 'interfaces';
import { BulkProviderIngestJob, BulkProviderIngestResult } from 'api/resource';
import { AddProviderModal } from './AddProviderModal';
import { ProviderFileUploadModal } from './ProviderFileUploadModal';
import { MRT_TableInstance } from 'mantine-react-table';
import { useIsAdmin, useCanModify } from 'hooks';

interface ProviderTopToolbarProps {
  table: MRT_TableInstance<Provider>;
  providers: Provider[];
  payors: Payor[];
  currentSite: Site;
  setAddProviderModal: (value: boolean) => void;
  setUploadModal: (value: boolean) => void;
  openRef: React.ForwardedRef<() => void | undefined>;
  providerFile: File[];
  setProviderFile: (value: File[]) => void;
  handleSubmitFile: () => void;
  uploadResult: BulkProviderIngestResult | null;
  uploadJob: BulkProviderIngestJob | null;
  isUploadingProviders: boolean;
  addProviderModal: boolean;
  uploadModal: boolean;
  handleCreateUser: (provider: Provider, email?: string) => Promise<User | null>;
}

export const ProviderTopToolbar = ({
  table,
  providers,
  payors,
  currentSite,
  setAddProviderModal,
  setUploadModal,
  openRef,
  providerFile,
  setProviderFile,
  handleSubmitFile,
  uploadResult,
  uploadJob,
  isUploadingProviders,
  addProviderModal,
  uploadModal,
  handleCreateUser,
}: ProviderTopToolbarProps) => {
  const { canModify } = useCanModify('providers');
  const isAdmin = useIsAdmin();
  return (
    <Flex justify="center" direction="column" gap="lg" align="center">
      <Group>
        <TableActionButton
          onClick={() => setAddProviderModal(true)}
          leftIcon={<IconUserPlus />}
          dataTestId="add-provider-button"
          disabled={!currentSite || !canModify}
        >
          Manage Providers
        </TableActionButton>
        {isAdmin && (
          <TableActionButton
            onClick={() => setUploadModal(true)}
            leftIcon={<IconUpload />}
            dataTestId="upload-provider-button"
            disabled={!canModify}
          >
            Bulk Upload
          </TableActionButton>
        )}
        {/* Add Provider Modal */}
        {addProviderModal && (
          <AddProviderModal
            addProviderModal={addProviderModal}
            setAddProviderModal={setAddProviderModal}
            siteProviders={providers}
            currentSite={currentSite}
            payors={payors}
            table={table}
            handleCreateUser={handleCreateUser}
          />
        )}
        {/* File Upload Modal */}
        <ProviderFileUploadModal
          uploadModal={uploadModal}
          setUploadModal={setUploadModal}
          openRef={openRef}
          providerFile={providerFile}
          setProviderFile={setProviderFile}
          handleSubmitFile={handleSubmitFile}
          uploadResult={uploadResult}
          uploadJob={uploadJob}
          isUploading={isUploadingProviders}
        />
      </Group>
    </Flex>
  );
};
